import { damageForCastLevel, parseSaveDamageDice } from './saveDamageDefinitions.mjs';

export const titleDamageType = (value) => String(value || 'untyped').trim().toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
export const formatDamageTypes = (components = []) => [...new Set(components.map((component) => titleDamageType(component.type)))].join(' + ');
export const formatSaveDamageTaken = (resolution) => `${resolution?.damageOutcome?.finalDamage} ${formatDamageTypes(resolution?.rules?.damage?.components)}`;
export const formatCastLevelDamage = (definition, level) => damageForCastLevel(definition, level).components
  .map((component) => `${component.formula} ${titleDamageType(component.type)}`).join(' + ');
export const saveDamageDiceGroups = (components) => {
  if (!Array.isArray(components) || !components.length) throw new Error('The server returned no damage components.');
  return components.map((component) => {
    const group = parseSaveDamageDice(component.formula);
    if (!group) throw new Error('The server returned an unsupported damage formula.');
    return group;
  });
};

export const formatSaveDamageTargeting = (area) => {
  if (!area) return 'Select one affected creature on the map.';
  if (area.perception === 'see-or-hear') return `${area.rangeFeet}-ft range — select one creature you can see or hear.`;
  const description = ({
    single: area.range === 'touch' ? 'Touch — single target' : area.rangeFeet ? `${area.rangeFeet}-ft range — single target` : 'Single target',
    cone: `${area.sizeFeet}-ft Cone`,
    line: `${area.lengthFeet}-ft × ${area.widthFeet}-ft line`,
    sphere: `${area.radiusFeet}-ft-radius sphere`,
    cube: `${area.sizeFeet}-ft cube`,
    cylinder: `${area.radiusFeet}-ft-radius, ${area.heightFeet}-ft-high cylinder`,
  })[area.shape] || 'Area effect';
  if (area.origin === 'self') return `${description} — aim from the caster and click. Failed saves push creatures 10 feet away; allies are included.`;
  if (area.maxAreas > 1) return `${description} — place ${area.minAreas === area.maxAreas ? area.minAreas : `${area.minAreas}–${area.maxAreas}`} areas, then Cast areas. Overlapping creatures save once.`;
  return ['cone', 'sphere', 'line', 'cube', 'cylinder'].includes(area.shape)
    ? `${description} — move the highlighted area and click to affect all living creatures inside. Allies are included.`
    : `${description} — manual targeting. Select one affected creature on the map.`;
};
